import { render } from "./IncomeCustomerReport.vue?vue&type=template&id=56159a53"
import script from "./IncomeCustomerReport.vue?vue&type=script&lang=js"
export * from "./IncomeCustomerReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__